<template>
	<div class="content">
		<div class="menu-bar">
			<div class="container">
				<Menubar></Menubar>
			</div>

		</div>
		<div id="top" class="top">
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title1">

				</p>
				<p class="subtitle" v-html="l10.All_Educators_Body_Title1_Description1">

				</p>
				<a class="button" href="https://secure.todomath.com/classroom/signup" v-html="l10.All_Educators_Body_Title1_button1"></a>
				<a class="button white" href="https://secure.todomath.com/educator/school_quote" v-html="l10.All_Educators_Body_Title1_button2" target="_blank"></a>
			</div>
		</div>
		<div id="article1">
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title2">

				</p>
				<p class="title-description"  v-html="l10.All_Educators_Body_Title2_Description1">

				</p>

					<div class="article">
						<p class="sub-title" v-html="l10.All_Educators_Body_Title2_Subtitle1">

						</p>
						<p class="description list"  v-html="l10.All_Educators_Body_Title2_Subtitle1_Description1">

						</p>
						<p class="description list"  v-html="l10.All_Educators_Body_Title2_Subtitle1_Description2">

						</p>
						<p class="description list"  v-html="l10.All_Educators_Body_Title2_Subtitle1_Description3">

						</p>

					</div>
					<div class="img">
						<img src="@/assets/educator/img-educator-feature-1.png"
						     srcset="@/assets/educator/img-educator-feature-1@2x.png 2x,
						             @/assets/educator/img-educator-feature-1@3x.png 3x">
					</div>



			</div>
		</div>

		<div id="article2">
			<div class="container">


				<div class="article">
					<p class="sub-title" v-html="l10.All_Educators_Body_Title2_Subtitle2">

					</p>
					<p class="description list white"  v-html="l10.All_Educators_Body_Title2_Subtitle2_Description1">

					</p>
					<p class="description list white"  v-html="l10.All_Educators_Body_Title2_Subtitle2_Description2">

					</p>
				</div>



			</div>
		</div>
<div id="article2-1">
    <div class="container">
        <div>
            <div class="article">
                <p class="sub-title">Remote Access for <br>
                    At-Home Learning
                </p>
                <p class="description list white">
                    Allow students to access Todo Math for the Classroom from a home tablet or smartphone
                </p>
                <p class="description list white">
                    Teachers can review students’ learning progress from the teacher dashboard
                </p>
            </div>
            <div class="img">
                <img src="@/assets/educator/img-educator-feature-3-m@3x.png" srcset="@/assets/educator/img-educator-feature-3-m@2x.png 2x,
                @/assets/educator/img-educator-feature-3-m@3x.png 3x" class="img_educator_feature_3">
            </div>
        </div>
    </div>
</div>
		<div id="article3" class="container">
			<p class="title" v-html="l10.All_Educators_Body_Title3">

			</p>
			<p class="title-description" v-html="l10.All_Educators_Body_Title3_Description1">

			</p>
			<div class="why-todo-img">
				<div>
					<img src="@/assets/educator/img-educator-why-1.png"
					     srcset="@/assets/educator/img-educator-why-1@2x.png 2x,
					             @/assets/educator/img-educator-why-1@3x.png 3x">
					<p v-html="l10.All_Educators_Body_Title3_Subtitle1">

					</p>
				</div>
				<div>
					<img src="@/assets/educator/img-educator-why-2.png"
					     srcset="@/assets/educator/img-educator-why-2@2x.png 2x,
					             @/assets/educator/img-educator-why-2@3x.png 3x" >
					<p v-html="l10.All_Educators_Body_Title3_Subtitle2">

					</p>
				</div>
				<div>
					<img src="@/assets/educator/img-educator-why-3.png"
					     srcset="@/assets/educator/img-educator-why-3@2x.png 2x,
					             @/assets/educator/img-educator-why-3@3x.png 3x">
					<p v-html="l10.All_Educators_Body_Title3_Subtitle3">

					</p>
				</div>
				<div>
					<img src="@/assets/educator/img-educator-why-4.png"
					     srcset="@/assets/educator/img-educator-why-4@2x.png 2x,
					             @/assets/educator/img-educator-why-4@3x.png 3x">
					<p v-html="l10.All_Educators_Body_Title3_Subtitle4">

					</p>
				</div>
			</div>


		</div>
		<div id="article4" class="container">
			<p class="sub-title" v-html="l10.All_Educators_Body_Title1_Subtitle1">
			</p>
			<div class="subjects">
				<div>
					<p v-html="l10.All_Educators_Body_Title1_Quote1">
					</p>
					<p v-html="l10.All_Educators_Body_Title1_Quote1_source1">
					</p>
				</div>
				<div>
					<p v-html="l10.All_Educators_Body_Title1_Quote2">
					</p>
					<p v-html="l10.All_Educators_Body_Title1_Quote2_source1">
					</p>
				</div>
				<div>
					<p v-html="l10.All_Educators_Body_Title1_Quote3">
					</p>
					<p v-html="l10.All_Educators_Body_Title1_Quote3_source1">
					</p>
				</div>
			</div>

		</div>
		<div id="article5">
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title4">

				</p>
				<p class="title-description" v-html="l10.All_Educators_Body_Title4_Description1">

				</p>
				<div class="download">

					<div>
						<p v-html="l10.All_Educators_Body_Title4_Subtitle1"></p>
						<a :href="getFile('2018_TodoMath_BacktoSchool_Flyer.pdf')" v-html="l10.All_Educators_Body_Title4_Button1" download></a>
					</div>
					<div>
						<p v-html="l10.All_Educators_Body_Title4_Subtitle2"></p>
						<a :href="getFile('Sample_Parent_Email_Color.docx')" v-html="l10.All_Educators_Body_Title4_Button2" download></a>
						<a :href="getFile('Sample_Parent_Email_BlackWhite-2.docx')" v-html="l10.All_Educators_Body_Title4_Button3" download></a>
					</div>
					<div>
						<p v-html="l10.All_Educators_Body_Title4_Subtitle3"></p>
						<a :href="getFile('2018_Parent_Resource_Guide.pdf')"  v-html="l10.All_Educators_Body_Title4_Button1" download></a>

					</div>
					<div>
						<p v-html="l10.All_Educators_Body_Title4_Subtitle4"></p>
						<a :href="getFile('2018_TodoMath_ActivityBook_Final.pdf')"  v-html="l10.All_Educators_Body_Title4_Button2" download></a>

					</div>

				</div>
			</div>
		</div>
		<div id="article6">
			<div class="container">
				<p class="title" v-html="">
					Start Todo Math now
					For your school and classroom
				</p>
				<a class="button white" href="https://secure.todomath.com/classroom/signup" v-html="l10.All_Educators_Body_Title1_button1"></a>
				<a class="button white" href="https://secure.todomath.com/educator/school_quote" v-html="l10.All_Educators_Body_Title1_button2"></a>

			</div>
		</div>

			<Footer>
			</Footer>


	</div>

</template>
<script>
import Menubar from '../../components/menubar/MobileLayout.vue'
import Footer from '@/components/footer/FooterMobile.vue'


export default {
  name: 'FeaturesLaptopFrame',
	components:{ Menubar,Footer},
	methods:{
		getFile(file){
			return require('@/assets/files/'+file);
		}
	},
	data () {
			const text = require('../../text/educator/mobile.js').default;
			const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];
	    return {
				l10:l10n
	    }
	}
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
		width:720px;
		padding:0 35px;
}
p.list::before{
	content:"";
	width: 16px;
  height: 6px;
  border-radius: 3px;
  background-color: #41403e;
  display: inline-block;
	position: relative;
  transform: translateY(-50%);
  margin-right:8px;
}
p.list.white::before{
  background-color: #fff;
}

.title{
	font-size: 64px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -2.5px;
  text-align: center;
  color: #41403e;

}
.title-description{
	font-size: 34px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: -1px;
  text-align: center;
  color: #41403e;


}
.title ~ .title-description{
	margin-top:16px;
}
.sub-title{
	width: 100%;
	font-size: 48px;
	font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: -2px;

}
.description{

	width: 100%;
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -0.9px;
}
.sub-title ~ .description{
	margin-top:33px;
}
.description ~ .description{
		margin-top:28px;
}
#top{
	width: 100%;
	height: 1280px;
	background-image: url('../../assets/educator/img-educator-top-bg-mb.jpg');
	background-size: 1600px auto;
	background-position:center;
	color:#fff;
	padding-top: 180px;
	padding-left: 11px;
	text-align: left;
}

#top .title{
	font-size: 56px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: -1.8px;
  color: #ffffff;


}
#top .subtitle{
	font-size: 34px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: -1px;
  text-align: center;

  margin-top: 16px;
}
#top .button:first-of-type{
	margin-top: 49px;
}
.button{
	display: flex;
	justify-content: center;
	align-items:center;
	width: 100%;
	  height: 100px;
	  object-fit: contain;
	  border-radius: 50px;
	  border: solid 3px #41403e;
	  font-size: 34px;
   font-weight: bold;
   font-style: normal;
   font-stretch: normal;
   line-height: normal;
   letter-spacing: -1.2px;
	 color:#41403e;
	 margin-top:16px;
}
.button.white{
	border-color: #fff;
	color:#fff;
}

#article1 {
	padding-top:120px;

	overflow: hidden;
}


#article1 .article{
	margin-top: 120px;
	margin-bottom: 80px;
}

#article1 .img{
	height:560px;
	margin-left:-20px;
}
#article1 .img>img{
  width: 964px;
  	height: auto;
}

#article2{
	background-image:url('../../assets/educator/img-educator-feature-2-m@2x.jpg');
	height:900px;
	background-size: 1600px auto;
	padding-top:120px;
	color:#fff;
	background-position: center;
}


#article2-1 {
    height: 1130px;
    width: 1600 auto;
    background-color: #75bd40;
    padding-top: 120px;
	color: #FFF;
}

#article2-1 .article {
    width: 650px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-top: 0px;
}

#article2-1 .container > div {
    display: flex;
    flex-direction: column;
    width: 100%;
}

#article2-1 > .container > div .img > img {
    width: 648px;
    height: 529px;
	margin-top: 60px;
}
#article2-1 p.list.white::before {
	background-color: #fff;
    position: absolute;
    transform: scale(0.8) translateX(-30px) translateY(20px);
}

#article2-1 .description {
	margin-left: 20px;
}

#article3{
	padding-top: 100px;
}
#article3::after{
	content:"";
	width:328px;
	position:absolute;
	border-bottom: 0;
	border-bottom: solid 1px #e6e6e6;
	left:50%;
	transform: translateX(-50%);
}
#article3 .why-todo-img{
	width: 100%;
	display: flex;
	margin-top:120px;
	font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -0.5px;
  text-align: center;
  color: #41403e;

  flex-wrap: wrap;

}

#article3 .why-todo-img>div{
	width: 50%;
	display: flex;
	flex-direction: column;
	  padding-bottom: 80px;

}
#article3 .why-todo-img>div>*{
	align-self: center;
}
#article3 .why-todo-img>div img {
	width: 192px;
    height: auto;
    margin-bottom: 18px;
}
#article3 .why-todo-img>div:nth-child(3) img {
	width: 209px;
}

#article4{
	padding-top:60px;
	padding-bottom: 120px;
	text-align: center;
}


#article4 .subjects{
	display: flex;
	flex-direction: column;
	margin-top: 80px;
}
#article4 .subjects>div ~div{
	margin-top:80px;
}
#article4 .subjects>div p:first-of-type{
	font-size: 28px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -1px;
  text-align: center;
  color: #41403e;
  margin-bottom: 16px;
}
#article4 .subjects>div p:last-of-type{
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -1px;
  text-align: center;

  color: #999999;
}
#article5{
	background-color: #fffcf7;
	padding-top:100px;
	padding-bottom: 123px;
}
#article5 .download{
	margin-top:83px;
}
#article5 .download>div{
	display: flex;
	flex-direction: column;
	padding:0 11px;

}
#article5 .download>div~div{
	margin-top:80px;
}

#article5 .download>div p{
	font-size: 34px;
 font-weight: bold;
 font-style: normal;
 font-stretch: normal;
 line-height: 1.35;
 letter-spacing: -1px;
  color: #41403e;
}
#article5 .download>div p~a{
	padding-top: 12px;
}
#article5 .download>div a{
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: -1px;

  color: #42c0ff;
  display: block;

}
#article5 .download>div>div a~a{
	padding-top:12px;
}
#article6{
	background-image: url('../../assets/educator/img-educator-try-bg-m@2x.jpg');
	background-size: 1600px auto;
	height: 828px;
	background-position: center;
	padding-top:80px;
	color:#fff;
}
#article6 .contaner{
	padding-left:11px;
}
#article6 .title{
	color:#fff;
	text-align: left;
	margin-bottom: 180px;
}
#article6 .button{
	 background-color: rgba(0, 0, 0, 0.3);
}
#article6 .button~.button{
	margin-top:16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educator/EducatorMobile.vue